import { render, staticRenderFns } from "./formEditSeller.vue?vue&type=template&id=6c21889a"
import script from "./formEditSeller.vue?vue&type=script&lang=js"
export * from "./formEditSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c21889a')) {
      api.createRecord('6c21889a', component.options)
    } else {
      api.reload('6c21889a', component.options)
    }
    module.hot.accept("./formEditSeller.vue?vue&type=template&id=6c21889a", function () {
      api.rerender('6c21889a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/sellers/components/form/formEditSeller.vue"
export default component.exports